import { gameInstance } from '@Game/GameComponent';
import { GameStore } from '@GameStore/GameStore';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { IActionResponseData } from '@GFTypes/Responses/ActionResponse';
import { EActionName } from '@Managers/Events/EActionName';
import { processAccountData } from './AccountDataProcessor';
import { processBetData } from './BetDataProcessor';
import { processErrorData } from './ErrorDataProcessor';

export const processAppData = (data: IActionResponseData & { actionName: EActionName }, gameStore: GameStore) => {
    if (data && data.error && data.code) {
        gameStore.set(EGameStoreKeys.GeneralAppState, { error: processErrorData(data.error, data.code) });
    } else {
        gameStore.set(EGameStoreKeys.Account, processAccountData(data, gameStore));
        if (shouldProcessBetData(data, gameStore)) {
            gameStore.set(
                EGameStoreKeys.BetState,
                processBetData({
                    account: data.account,
                    currentState: gameStore.get(EGameStoreKeys.BetState),
                    bonuses: gameStore.get(EGameStoreKeys.Account).bonuses
                })
            );
            gameStore.set(EGameStoreKeys.GeneralAppState, {
                insufficientFunds: !gameStore.get(EGameStoreKeys.BetState).available && gameInstance.betManager.getCurrentSpinBet() > 0
            });
        }
    }
};

const shouldProcessBetData = (data: IActionResponseData & { actionName: EActionName }, gameStore: GameStore) => {
    const outcome = data?.result?.outcome;
    const outcomes = outcome ? (Array.isArray(outcome) ? outcome : [outcome]) : [];

    const hasSpecialGames = outcomes.some((outcome) => outcome?.specialGames);
    const currentSpecialGamesType = gameStore.get(EGameStoreKeys.CurrentSpecialGamesType);

    const isGameRestored = gameStore.get(EGameStoreKeys.IsGameRestored);
    const { gameTypeAfter } = isGameRestored ? gameStore.get(EGameStoreKeys.ResumedSpinOutcome)! : gameStore.get(EGameStoreKeys.SpinOutcome);

    return (!hasSpecialGames && !currentSpecialGamesType) || (gameTypeAfter === 1 && data.actionName === EActionName.TAKE);
};
